import axios from 'axios';

const BASE_URL = '/api/preguntas-frecuentes';

export const fqasRegisterService = {
  registerFQAs: async (empresaId, data) => {
    // data: { codigoProyecto, questions: [...] }
    try {
      const response = await axios.post(`${BASE_URL}/register`, data);
      return response.data;
    } catch (error) {
      console.error('Error registering FAQs:', error);
      throw error;
    }
  }
};
